/*
 * @Date: 2021-03-10 16:18:26
 * @author: yanhoup
 * @description: 路由
 */
import React from 'react';
import BasicLayout from '@/layouts/BasicLayout';
import BillBoard from '@/pages/Billboard';
import inboundRoutes from './routes/inboundRoutes';
import outboundRoutes from './routes/outboundRoutes';
import baseDataRoutes from './routes/baseDataRoutes';
import orderRoutes from './routes/orderRoutes';
import UserLayout from './layouts/UserLayout';
import Login from './pages/Login';
import insideRoutes from './routes/insideRoutes';
import billboardRoutes from './routes/billboardRoutes';
import OperatePack from './pages/OperatePack';
import automationRoutes from './routes/automationRoutes';
import goodsRoutes from './routes/goodsRoutes';
import FpxDemo from './pages/FpxDemo';
import InboundOrder from './pages/InboundOrder';
import DdLoginLoding from './pages/Login/components/LoginBlock/DdLoginLoading';
import serviceRoutes from './routes/serviceRoutes';
import TetentionDetails from './pages/TetentionDetails';
import allocateRoutes from './routes/allocateRoutes';
import fbaRoutes from './routes/fbaRoutes';
import devRoutes from './routes/devRoutes';
import errorRoutes from './routes/errorRoutes';
import returnServiceRoutes from './routes/returnServiceRoutes';

const routerConfig = [
  {
    path: '/user',
    component: UserLayout,
    children: [
      {
        path: '/login',
        // component: Login,
        component: React.lazy(() => import(/* webpackChunkName: 'Login' */ './pages/Login')),
      },
      {
        path: '/',
        redirect: '/user/login',
      },
    ],
  },
  // 钉钉登录loading页
  {
    path: '/ddLoginLoding',
    // component: DdLoginLoding,
    component: React.lazy(
      () => import(/* webpackChunkName: 'ddLoginLoding' */ './pages/Login/components/LoginBlock/DdLoginLoading'),
    ),
  },
  {
    path: '/FpxDemo/FpxDemo',
    component: FpxDemo,
  },
  {
    path: '/TetentionDetails',
    // component: TetentionDetails,
    component: React.lazy(() => import(/* webpackChunkName: 'TetentionDetails' */ './pages/TetentionDetails')),
  },
  {
    path: '/',
    component: BasicLayout,
    children: [
      ...inboundRoutes,
      ...outboundRoutes,
      ...baseDataRoutes,
      ...insideRoutes,
      ...billboardRoutes,
      ...automationRoutes,
      ...goodsRoutes,
      ...orderRoutes,
      ...serviceRoutes,
      ...allocateRoutes,
      ...fbaRoutes,
      ...devRoutes,
      ...errorRoutes,
      ...returnServiceRoutes,
      {
        path: '/',
        component: BillBoard,
        exact: true,
      },
    ],
  },
];
export default routerConfig;
